// extracted by mini-css-extract-plugin
module.exports = {"boxLink":"box-link-module--box-link--2MiaC","fakeLink":"box-link-module--fake-link--wcviA link-module--gradient-link--3yNTy"};